export default "__VITE_ASSET__6191fb25__"